import { render } from "./landing.vue?vue&type=template&id=43343612"
import script from "./landing.vue?vue&type=script&lang=js"
export * from "./landing.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/nikrahan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__